import { useQuery } from "@apollo/client";
import { QUERY_SALES_COUNT } from "../../modules/sales/utils";
import { Badge, Colors } from "react-native-ui-lib";

export const PendingSalesCountChip = () => {
  const { data, loading, error } = useQuery(QUERY_SALES_COUNT, {
    fetchPolicy: "cache-and-network",
    pollInterval: 30000,
    variables: {
      options: {
        filter: {
          state: {
            in: ["SAVED", "INVOICE_SAVED", "QUOTE_SAVED", "LAYBY_SAVED"],
          },
        },
      },
    },
  });

  if (loading || error) {
    return null;
  }

  return (
    <Badge
      label={(data?.salesCount ?? 0).toString()}
      labelStyle={{
        color: Colors.black,
      }}
      backgroundColor="rgb(216, 217, 219)"
    />
  );
};
